import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import NavHeader from './NavHeader';
import { GoogleLogin } from "@react-oauth/google";
import styles from './choose-username.module.css';
import Footer from '../shared/Footer';
import IndianFlag from '../images/flag-india.png';
import GrowingArrow from '../images/growing-arrow.png';
import Exchange from '../images/exchange.png';
import Secure from '../images/secure.png';

const ChooseUsername = () => {
    const [username, setUsername] = useState('');
    const [status, setStatus] = useState(null); // null | 'checking' | 'available' | 'taken' | 'invalid'
    const [notification, setNotification] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const debounceRef = useRef(null);

    const handleUsernameChange = (e) => {
        const val = e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '');
        setUsername(val);

        if (!val) { setStatus(null); return; }
        if (val.length < 3) { setStatus('short'); return; }

        setStatus('checking');
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(async () => {
            try {
                const res = await axios.get(`/api/authApplicant/check-username/${val}`);
                setStatus(res.data.available ? 'available' : 'taken');
            } catch {
                setStatus(null);
            }
        }, 500);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (status !== 'available') return;
        setLoading(true);
        try {
            const res = await axios.post('/api/authApplicant/quick-signup', { username });
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('notification', `Welcome, ${username}!`);
            navigate('/');
        } catch (err) {
            const msg = err.response?.data?.message || 'Something went wrong.';
            setNotification(msg);
            if (msg.toLowerCase().includes('taken')) setStatus('taken');
        } finally {
            setLoading(false);
        }
    };

    const statusInfo = {
        checking: { text: 'Checking…', color: '#9ca3af' },
        available: { text: '✓ Available', color: '#16a34a' },
        taken: { text: '✗ Already taken', color: '#ef4444' },
        invalid: { text: 'Letters, numbers, _ only', color: '#f59e0b' },
        short: { text: 'At least 3 characters', color: '#9ca3af' },
    };

    return (
        <>
        <NavHeader />
        {notification && <Notification message={notification} onClose={() => setNotification('')} />}

        <div className={styles.chooseUsernamePage}>
            <div className={styles.card}>

                <div className={styles.cardHeader}>
                    <div className={styles.badge}>
                        <span className={styles.badgeDot}></span>
                        The ultimate Learn — Teach  App!
                    </div>
                    <h1 className={styles.headline}>
                        <span className={styles.exchangeText}> Exchange</span>
                        <span className={styles.skillsText}> Skills</span>
                        <span className={styles.comma}>, </span>
                          Chapters
                        <span className={styles.comma}>, </span>

                        <span className={styles.topicsText}> Topics</span> With 

                        <span className={styles.topicsText}> Friends</span>
                        <span className={styles.fullStop}>.</span>
                    </h1>
                    
                    {/* <div className={styles.trustRow}>
                        <div className={styles.trustItem}>📈 Growing users</div>
                        <div className={styles.trustItem}>⚡ 10 seconds</div>
                        <div className={styles.trustItem}>🔒 Secure</div>
                    </div> */}
                    <div className={styles.trustRow}>
                        {/* <div className={styles.trustItem}><img  title="India" src={GrowingArrow.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.GrowingArrow}/> Growing Users</div> */}
                        {/* <div className={styles.trustItem}>⚡ Join in 30 seconds</div> */}
                            {/* <div className={styles.trustItem}><img src={Exchange.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/> Exchange Skills-Chapters-Topics</div> */}
                        <div className={styles.trustItem}><img  title="India" src={IndianFlag.replace('/upload/', '/upload/w_192,h_200,c_fill/')} className={styles.IndianFlag}/>Made in India</div>
                        {/* <div className={styles.trustItem}><img src={Secure.replace('/upload/', '/upload/w_96,h_100,c_fill/')} className={styles.IndianFlag}/> 100% Safe & Secure</div> */}
                        <div className={styles.trustItem}>🔒 100% Safe & Secure</div>
                    </div>
                </div>

                <div className={styles.cardBody}>

                    {/* Google — still available */}
                    {/* <div className={styles.googleWrapper}>
                        <GoogleLogin
                            onSuccess={async (credentialResponse) => {
                                try {
                                    const res = await axios.post("/api/authApplicant/google", { credential: credentialResponse.credential });
                                    localStorage.setItem("token", res.data.token);
                                    navigate("/home");
                                } catch (err) {
                                    const msg = err.response?.data?.message || "Google Login Failed";
                                    setNotification(msg);
                                }
                            }}
                            onError={() => setNotification("Google Login Failed")}
                            size="large"
                            text="signup_with"
                            theme="outline"
                            shape="rectangular"
                            width="368"
                        />
                    </div> */}



                    <form onSubmit={handleSubmit} className={styles.chooseUsernameForm}>
                        <h1 className={styles.selectUsernameHeadline}>Select a username</h1>
                        <div className={styles.fieldWrap}>
                            <span className={styles.fieldPrefix}>@</span>
                            <input
                                className={`${styles.input} ${styles.inputUsername} ${
                                    status === 'available' ? styles.inputValid :
                                    status === 'taken' ? styles.inputInvalid : ''
                                }`}
                                type="text"
                                placeholder="username"
                                value={username}
                                onChange={handleUsernameChange}
                                maxLength={20}
                                autoComplete="off"
                                autoCapitalize="none"
                                required
                            />
                            {status && statusInfo[status] && (
                                <span className={styles.statusBadge} style={{ color: statusInfo[status].color }}>
                                    {statusInfo[status].text}
                                </span>
                            )}
                        </div>

                        {/* <p className={styles.hintText}>Letters, numbers and _ only · 3–20 characters</p> */}

                        <button
                            type="submit"
                            className={styles.submitBtn}
                            disabled={status !== 'available' || loading}
                        >
                            {loading ? 'Creating account…' : 'Create my account →'}
                        </button>

                        {/* <p className={styles.freeLabel}>
                            ✓ <span>Free forever</span> &nbsp;·&nbsp; No spam &nbsp;·&nbsp; Add email anytime
                        </p> */}
                        <p className={styles.freeLabel}>
                        {/* ✓ <span>Easy access</span> */}
                                {/* &nbsp;·&nbsp; No spam &nbsp;·&nbsp; */}
                                {/* <b>&nbsp;·&nbsp; We value your privacy and security. </b> */}
                        </p>
                        <p className={styles.freeLabel}>No email needed. </p>
                    </form>
                                
                </div>

                {/* <div className={styles.cardFooter}>
                    Already have an account? <a href="/login">Log in</a>
                </div> */}
                <div className={styles.divider}>
                    <div className={styles.dividerLine}></div>
                    <span className={styles.dividerText}>via-google</span>
                    <div className={styles.dividerLine}></div>
                </div>
                <div className={styles.googleWrapper}>
                        <GoogleLogin
                            onSuccess={async (credentialResponse) => {
                                try {
                                    const res = await axios.post("/api/authApplicant/google", { credential: credentialResponse.credential });
                                    localStorage.setItem("token", res.data.token);
                                    navigate("/");
                                } catch (err) {
                                    const msg = err.response?.data?.message || "Google Login Failed";
                                    setNotification(msg);
                                }
                            }}
                            onError={() => setNotification("Google Login Failed")}
                            size="large"
                            type="icon"
                            theme="outline"
                            shape="square"
                        />

                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default ChooseUsername;